export default __webpack_public_path__ + "static/media/symbol02.10a0b6d7.svg";